<script>
    import { mapActions, mapState } from "vuex";
    import { checkOrderPage, checkModalQuery } from "@/utils";
    import TheModal from "@main/packages/TheModal";
    import TheTopBanner from "@main/packages/TheTopBanner";
    // import NewYearButton from "@/components/NewYearButton";
    import SelectCityConfirmation from "@/components/SelectCityConfirmation";
    import AppSchema from "@/components/AppSchema";
    import TheHeaderTop from "@miku-kz/components/TheHeaderTop";
    import TheHeaderMobile from "@miku-kz/components/TheHeaderMobile";
    import TheHeaderMain from "@miku-kz/components/TheHeaderMain";
    import TheFooter from "@miku-kz/components/TheFooter";

    export default {
        components: {
            AppSchema,
            // NewYearButton,
            TheModal,
            TheTopBanner,
            TheHeaderMain,
            TheHeaderMobile,
            TheHeaderTop,
            SelectCityConfirmation,
            TheFooter,
        },
        data() {
            return {
                isOrderPage: checkOrderPage(this.$router),
            };
        },
        computed: {
            ...mapState("Root", {
                topBanner: (state) => state.site.topBanner,
                city: (state) => state.city,
                phone: (state) => state.site.phone,
                topMenu: (state) => state.site.topMenu,
                centerMenu: (state) => state.site.mainMenu,
                freeDeliveryCount: (state) => state.site.freeDelivery,
                phoneCallCenter: (state) => state.site.options.phoneCallCenter,
                cart: (state) => state.cart,
            }),
        },
        serverPrefetch() {
            return this.getDataSite();
        },
        watch: {
            $route() {
                this.isOrderPage = checkOrderPage(this.$router);
            },
        },
        mounted() {
            this.getDefaultCity();
            this.getCart();
            if (!this.$route.name.startsWith("ThePersonal")) {
                this.getProfileUser();
            }
            checkModalQuery(this.$route, this.$popup);
        },
        methods: {
            ...mapActions("Root", ["getDataSite", "getDefaultCity", "getCart"]),
            ...mapActions("Profile", ["getProfileUser"]),
        },
    };
</script>

<template>
    <div id="app" class="app">
        <the-top-banner :banner="topBanner" :city="city"></the-top-banner>

        <select-city-confirmation
            :city="city"
            variant-submit-button="v1"
            variant-cancel-button="v2"
        ></select-city-confirmation>

        <the-header-top
            :phone-call-center="phoneCallCenter"
            :top-menu="topMenu"
            :city="city"
        ></the-header-top>

        <the-header-main
            :center-menu="centerMenu"
            :cart="cart"
            :free-delivery-count="freeDeliveryCount"
            :is-order-page="isOrderPage"
        ></the-header-main>

        <the-header-mobile
            :top-menu="topMenu"
            :center-menu="centerMenu"
            :city="city"
            :cart="cart"
            :free-delivery-count="freeDeliveryCount"
            :is-order-page="isOrderPage"
            :phone-call-center="phoneCallCenter"
            :is-top-banner="true"
        ></the-header-mobile>

        <router-view />

        <the-footer></the-footer>

        <the-modal></the-modal>
        <!--        <new-year-button v-if="!isOrderPage"></new-year-button>-->

        <app-schema
            address-locality="Алматы, Республика Казахстан"
            street-address="ул. Потанина 47/26"
            postal-code="050002"
            name="Грили и контейнеры MIKU для приготовления блюд в микроволновой печи. Официальный интернет-магазин. Доставка по всей территории Республики Казахстан"
            alternate-name="Грили и контейнеры MIKU для приготовления блюд в микроволновой печи"
            description="Грили и контейнеры MIKU для готовки в микроволновой печи. Термосы, термокувшины, термокружки для заваривания чая и кофе. Покупка в интернет-магазине. Доставка по Казахстану"
            url="https://miku.kz/"
            email="miku.kazakhstan@gmail.com"
            :phone="phone"
        ></app-schema>
    </div>
</template>

<style lang="scss">
    @import "~@/assets/sass/main.scss";
    @import "~@/assets/sass/custom-properties/index.scss";
    @import "~@miku-kz/assets/sass/vars.scss";

    @import "~@miku-kz/style/TheLogo.scss";
    @import "~@miku-kz/style/TopNavigationMenu.scss";
    @import "~@miku-kz/style/CenterNavigationMenu.scss";
    @import "~@miku-kz/style/HeaderStatusOrder.scss";
    @import "~@miku-kz/style/SelectCityConfirmation.scss";
    @import "~@miku-kz/style/SelectCity.scss";

    .app {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
    }

    .page-title {
        font-size: 18px;
        font-weight: 700;
        line-height: 22px;
        text-align: center;
        @include bp($bp-desktop-sm) {
            font-size: 36px;
            line-height: 44px;
        }
    }
</style>
